import { Grid, Tooltip, Typography } from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { Button, useShowController } from "react-admin";
import DisabledButtonWithTip from "../../unit/DisabledButtonWithTip";
import useNotify from "../../unit/useNotify";
import CustomApproved2CompletedFormDialog from "../actions/CustomApproved2CompletedFormDialog";
import CustomApproved2DisburseFormDialog from "../actions/CustomApproved2DisburseFormDialog";
import CustomApproved2DisburseOutHMFormDialog from "../actions/CustomApproved2DisburseOutHMFormDialog";
import CustomApproved2ExpiredDialog from "../actions/CustomApproved2ExpiredDialog";
import CustomApproved2SwitchACHFormDialog from "../actions/CustomApproved2SwitchACHFormDialog";
import CustomApprovedFormDialog from "../actions/CustomApprovedFormDialog";
import CustomCounter2ApproveDialog from "../actions/CustomCounter2ApproveDialog";
import CustomCounter2DeclineDialog from "../actions/CustomCounter2DeclineDialog";
import CustomCounter2ExpiredDialog from "../actions/CustomCounter2ExpiredDialog";
import CustomCounteredFormDialog from "../actions/CustomCounteredFormDialog";
import CustomCounterReminderDialog from "../actions/CustomCounterReminderDialog";
import CustomDeclinedFormDialog from "../actions/CustomDeclinedFormDialog";
import CustomExpired2DeclineDialog from "../actions/CustomExpired2DeclineDialog";
import CustomExpired2OfflineDialog from "../actions/CustomExpired2OfflineDialog";
import CustomExpired2ResendDialog from "../actions/CustomExpired2ResendDialog";
import CustomHold2DeclinedFormDialog from "../actions/CustomHold2DeclinedFormDialog";
import CustomHold2ResumeFormDialog from "../actions/CustomHold2ResumeFormDialog";
import CustomHoldFormDialog from "../actions/CustomHoldFormDialog";
import CustomInitiateReviewFormDialog from "../actions/CustomInitiateReviewFormDialog";
import CustomOverrideFormDialog from "../actions/CustomOverrideFormDialog";
import CustomPreApprove2ApproveDialog from "../actions/CustomPreApprove2ApproveDialog";
import CustomPreApprove2ExpiredDialog from "../actions/CustomPreApprove2ExpiredDialog";
import CustomPreApprove2ReminderDialog from "../actions/CustomPreApprove2ReminderDialog";
import CustomProceedFormDialog from "../actions/CustomProceedFormDialog";
import CustomRejectFormDialog from "../actions/CustomRejectFormDialog";
import CustomToNotify2ApprovedFormDialog from "../actions/CustomToNotify2ApprovedFormDialog";
import CustomToNotify2CounteredFormDialog from "../actions/CustomToNotify2CounteredFormDialog";
import CustomToNotify2DeclinedFormDialog from "../actions/CustomToNotify2DeclinedFormDialog";
import CustomToNotify2PreApprovedFormDialog from "../actions/CustomToNotify2PreApprovedFormDialog";
import MoveBulkUpdateButton from "../actions/MoveBulkUpdateButton"; // Adjust the path as necessary
import { Link } from "react-admin";
import CustomArrowCircleLeftSharpIcon from "../../unit/CustomArrowCircleLeftSharpIcon";
import CustomApproved2DisburseNoAchConfirmDialog from "../actions/CustomApproved2DisburseNoAchConfirmDialog";
import CustomLoanPortfolioDialog from "../../loans/actions/CustomLoanPortfolioDialog";
import CustomExpiredDialog from "../actions/CustomExpiredDialog";
const ApplicationActions = ({ ...props }) => {
  const paramAppId = props.appId;
  let appId = "";
  let record = props.record;
  const appStatus = props?.appStatus;
  const adverseAction = record?.adverseAction;
  // console.log("============>", adverseAction);
  let appVoided = false;
  if (adverseAction) {
    const adverseActionArray = adverseAction.split(",");
    if (
      adverseActionArray.includes("57") ||
      adverseActionArray.includes("67")
      // adverseActionArray.includes("71")
    ) {
      appVoided = true;
    }
  }
  // console.log("appStatus:===>", appStatus);
  const requirementSaved = props?.requirementSaved;
  const isMounted = React.useRef(false);
  const renderCountRef = React.useRef(0);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      renderCountRef.current += 1;
    }
  });

  const handleNewAppStatus = (status: string) => {
    props.cb(status);
  };
  const handleCallBackRefreshMenu = () => {
    if (typeof props?.handleCallBackRefreshMenu === "function") {
      props.handleCallBackRefreshMenu();
    }
  };
  if (paramAppId != undefined && record != undefined) {
    appId = paramAppId;
  } else {
    const controllerProps = useShowController();
    record = controllerProps.record;
    appId = record ? record.id : "";
  }

  const [isLoading, setIsLoading] = useState(true);
  const { success, warning, error, info } = useNotify();

  useEffect(() => {
    if (appId) {
      setIsLoading(false);
    }
  }, [appId]);

  if (isLoading) {
    return <Typography>Application Action Loading...</Typography>;
  }
  if (record == undefined) {
    return <Typography>Application Action Loading...</Typography>;
  }

  const handleClick = (label: string) => {
    info(label + " Button is clicked");
  };

  //approved page buttons
  const BorrowerAgreement = ({ record }: { record: any }) => {
    const attachAttrs = record?.attachAttrs;
    if (
      attachAttrs == undefined ||
      attachAttrs == null ||
      attachAttrs == "" ||
      !attachAttrs
    ) {
      // return <>Missing Data</>;
      return null;
    }
    let borrowerAgreement = "";
    let showSwitchACH = false;
    let lenderaction = "";

    if (attachAttrs?.isAch == "NO") {
      if (attachAttrs?.executeStatus == "Closing Dos Received") {
        borrowerAgreement = "Signature Completed";
      } else {
        borrowerAgreement = "Pending Signature";
      }
    } else {
      if (attachAttrs?.payment_type == "NOTACH") {
        if (
          attachAttrs?.executeStatus == "Closing Dos Received" &&
          attachAttrs?.hasPaymentMethod
        ) {
          borrowerAgreement = "Signature Completed";
        } else {
          if (!attachAttrs?.hasPaymentMethod) {
            if (attachAttrs?.disbursement_status == "no disbursement") {
              // borrowerAgreement = "no disbursement";
            } else if (
              attachAttrs?.disbursement_status != "success" &&
              attachAttrs?.disbursement_status != "failed"
            ) {
            } else {
              borrowerAgreement = "Pending ACH";
            }
            showSwitchACH = true;
          }
          if (attachAttrs?.executeStatus != "Closing Dos Received") {
            if (!attachAttrs?.hasPaymentMethod) {
              borrowerAgreement += ",";
            }
            if (attachAttrs?.executeStatus == "ID check failed") {
              borrowerAgreement += "Signature Failed";
            } else {
              borrowerAgreement += "Pending Signature";
            }
          }
        }
      } else {
        if (
          attachAttrs?.executeStatus == "Closing Dos Received" &&
          attachAttrs?.hasPaymentMethod
        ) {
          borrowerAgreement = "Signature Completed";
        } else {
          if (!attachAttrs?.hasPaymentMethod) {
            if (attachAttrs?.disbursement_status == "no disbursement") {
              // borrowerAgreement = "no disbursement";
            } else if (
              attachAttrs?.disbursement_status != "success" &&
              attachAttrs?.disbursement_status != "failed"
            ) {
            } else {
              borrowerAgreement = "Pending ACH";
            }
            showSwitchACH = true;
          }
          if (attachAttrs?.executeStatus != "Closing Dos Received") {
            if (!attachAttrs?.hasPaymentMethod) {
              borrowerAgreement += ",";
            }
            if (attachAttrs?.executeStatus == "ID check failed") {
              borrowerAgreement += "Signature Failed";
            } else {
              borrowerAgreement += "Pending Signature";
            }
          } else {
            if (borrowerAgreement) {
              borrowerAgreement += ",Signature Completed";
            } else {
              borrowerAgreement = "Signature Completed";
            }
          }
        }
      }
    }
    let showFinalizeButton = false;
    let showDisburseButton = false;
    let showDisburseOutHMButton = false;
    let showCompleteButton = false;
    let showConfirmNoAchDisburseButton = false;

    if (
      borrowerAgreement.toLowerCase() == "completed" ||
      borrowerAgreement.toLowerCase() == "signature completed"
    ) {
      //if(loantype == 'mortgage' || loantype == 'car' || loantype == 'purchasecar' || loantype == 'refinancecar')
      if (
        (record.sSubType == "mortgage" ||
          record.sSubType == "car" ||
          record.sSubType == "purchasecar" ||
          record.sSubType == "refinancecar") &&
        attachAttrs.payment_type != "REPAYMENT" &&
        attachAttrs.payment_type != "ACH"
      ) {
        if (attachAttrs.fund_status != "FINALIZED") {
          lenderaction = "Finalize";
          showFinalizeButton = true;
        }
      } else {
        if (
          attachAttrs.payment_type == "ACH" ||
          attachAttrs.payment_type == "DISBURSEMENT" ||
          attachAttrs.payment_type == "REPAYMENT"
        ) {
          if (
            attachAttrs.fund_status != "DISBURSEMENT_FUNDED" &&
            attachAttrs.fund_status != "COMPLETED" &&
            attachAttrs.disbursement_status != "no disbursement"
          ) {
            lenderaction = "show Disbursement";
            //disburse button should show
            if (record.sDisbursementPayment == "SMART_ACH_Vendor") {
              if (attachAttrs.vendorVerifyStatus == "Purchase Completed") {
                showDisburseButton = true;
              }
            } else {
              showDisburseButton = true;
            }
          }
          if (attachAttrs.disbursement_status == "no disbursement") {
            lenderaction = "Completed";
          }
          // console.log("aaaaaaaaaaaaa====>", lenderaction);
        } else {
          lenderaction = "Disburse Funds";
          if (attachAttrs.disbursement_time != "inception") {
            lenderaction = "Completed";
          }
        }
      }
    }
    if (lenderaction == "") {
      lenderaction = "Completed";
    }

    //{{{{{{{{{{
    let new_pending_ach = "";
    let new_disbursement_status = "";
    let new_vendor = "";
    let new_sign = attachAttrs?.executeStatus;
    let sNeedDisbursement = record?.sNeedDisbursement;
    if (
      sNeedDisbursement == "" &&
      record?.sDisbursementPayment != "SMART_ACH"
    ) {
      sNeedDisbursement = "No";
    }
    let vendor_id = record?.vendor_id;
    let vendor_verify = record?.attachAttrs?.vendorVerifyStatus;
    let showVendorDisburseButton = false;
    console.log(
      ">>>>>>disbursementStatus===============",
      record?.disbursementStatus
    );
    if (record?.disbursement_status == "no disbursement") {
      new_disbursement_status = "No Disbursement";
    } else {
      if (
        record?.disbursementStatus == "succeed" ||
        record?.disbursementStatus == "Offline" ||
        record?.disbursementStatus == "processed"
      ) {
        new_disbursement_status = "Disbursement Succeed";
      } else if (record?.disbursementStatus == "failed") {
        new_disbursement_status = "Disbursement Failed";
      } else if (
        record?.disbursementStatus == "start" ||
        record?.disbursementStatus == "executing"
      ) {
        new_disbursement_status = "in Progress";
      } else {
        if (sNeedDisbursement == "No") {
          new_disbursement_status = "No Disbursement";
        } else {
          new_disbursement_status = "Pending Disburse";
        }
      }
    }

    if (record?.ach_account_id == null) {
      if (record?.sRepaymentPayment == "SMART_ACH") {
        new_pending_ach = "Pending ACH";
      } else {
        new_pending_ach = "No ACH";
      }
    } else {
      new_pending_ach = "ACH Completed";
    }

    showCompleteButton = false;

    if (new_sign == "Closing Dos Received") {
      if (
        new_disbursement_status == "No Disbursement" ||
        new_disbursement_status == "Disbursement Succeed"
      ) {
        showCompleteButton = true;
      } else {
        if (new_pending_ach == "No ACH" || new_pending_ach == "ACH Completed") {
          if (new_disbursement_status == "Pending Disburse") {
            showCompleteButton = false;
          } else {
            showCompleteButton = true;
          }
        }
      }
      if (
        record?.sDisbursementPayment == "SMART_ACH_Vendor" &&
        vendor_verify == "Purchase Completed"
      ) {
        showCompleteButton = true;
      }

      if (new_disbursement_status == "in Progress") {
        showCompleteButton = false;
      }

      console.log(
        "new_disbursement_status ===============>",
        "[" + new_disbursement_status + "]"
      );
      if (new_disbursement_status == "No Disbursement") {
        //如果时Offline, no Disbursement, 则需要点击一个disburse confirm 按钮，才能完成后续流程，所以先不显示Complete按钮 sConfirmNoACHDisburse
        console.log(
          "record?.sConfirmNoACHDisburse ==>",
          record?.sConfirmNoACHDisburse
        );
        if (record?.sConfirmNoACHDisburse == "NO") {
          showCompleteButton = false;
          showConfirmNoAchDisburseButton = true;
        } else {
          showCompleteButton = true;
          showConfirmNoAchDisburseButton = false;
        }
      }
    }

    if (
      new_sign == "Closing Dos Received" &&
      new_disbursement_status == "Pending Disburse" &&
      (new_pending_ach == "ACH Completed" || new_pending_ach == "No ACH")
    ) {
      showDisburseButton = true;
    } else {
      showDisburseButton = false;
    }

    if (
      new_disbursement_status == "No Disbursement" ||
      lenderaction == "Completed"
    ) {
      showSwitchACH = false;
    }
    if (
      new_disbursement_status == "Pending Disburse" &&
      sNeedDisbursement == "Yes"
    ) {
      showSwitchACH = true;
    }

    console.log("appID ==>", appId);
    console.log("disbursement type ==>", record?.sDisbursementPayment);
    console.log("repayment type ==>", record?.sRepaymentPayment);
    console.log("sNeedDisbursement ==>", record?.sNeedDisbursement);
    console.log("sNeedDisbursement ==>", sNeedDisbursement);
    console.log("new_disbursement_status ==>", new_disbursement_status);
    console.log("new_sign ==>", new_sign);
    console.log("new_pending_ach ==>", new_pending_ach);
    console.log("lender action ==>", lenderaction);
    console.log("showSwitchACH ==>", showSwitchACH);
    console.log("sConfirmNoACHDisburse ==>", record?.sConfirmNoACHDisburse);
    console.log(
      "showConfirmNoAchDisburseButton ==>",
      showConfirmNoAchDisburseButton
    );
    console.log("showCompleteButton ==>", showCompleteButton);
    console.log("showDisburseButton ==>", showDisburseButton);
    console.log("vendor_verify ==>", vendor_verify);
    console.log("vendor_id ==>", vendor_id);

    let completeBtnTip = "";
    if (new_sign != "Closing Dos Received") {
      completeBtnTip = "Pending Signature";
    }
    if (new_pending_ach == "Pending ACH") {
      completeBtnTip = completeBtnTip
        ? completeBtnTip + ",Pending ACH"
        : "Pending ACH";
    }
    if (new_disbursement_status == "Disbursement Failed") {
      completeBtnTip = completeBtnTip
        ? completeBtnTip + ",Disbursement Failed"
        : "Disbursement Failed";
      showDisburseOutHMButton = true;
    }

    if (
      record?.sDisbursementPayment == "SMART_ACH_Vendor" &&
      vendor_verify != "Purchase Completed"
    ) {
      completeBtnTip = completeBtnTip
        ? completeBtnTip + ",Pending Purchase"
        : "Pending Purchase";
    }

    //}}}}}}}}}}}}}}}}}}}}

    let disbursementStatus = "";
    let checkSign = borrowerAgreement;
    if (checkSign == "Pending Signature") {
      let signLog = "";
      if (
        attachAttrs?.signLog &&
        attachAttrs.signLog != undefined &&
        attachAttrs.signLog != null
      ) {
        attachAttrs.signLog.map(
          (sv: { role: string; email: string; status?: string }) => {
            signLog +=
              "[" +
              sv.role +
              "] " +
              sv.email +
              " : " +
              (sv.status ? sv.status : "pending") +
              "<br>";
          }
        );
      }
      return null;
    } else {
      return (
        <>
          {/* {showFinalizeButton && (
            <Button
              label={lenderaction}
              variant="contained"
              size="medium"
              color="primary"
              onClick={() => handleClick("Finalize Pop-up ...")}
            />
          )} */}

          {showDisburseButton ? (
            <CustomApproved2DisburseFormDialog
              appId={appId}
              record={record}
              cb={handleNewAppStatus}
            />
          ) : (
            <>
              {showDisburseOutHMButton && (
                <CustomApproved2DisburseOutHMFormDialog
                  appId={appId}
                  record={record}
                  cb={handleNewAppStatus}
                />
              )}
            </>
          )}

          {showConfirmNoAchDisburseButton && (
            <CustomApproved2DisburseNoAchConfirmDialog
              appId={appId}
              record={record}
              cb={handleNewAppStatus}
            />
          )}

          {showSwitchACH && (
            <CustomApproved2SwitchACHFormDialog
              appId={appId}
              record={record}
              cb={handleNewAppStatus}
            />
          )}
          {showCompleteButton && (
            <>
              {(attachAttrs.payment_type == "ACH" ||
                attachAttrs.payment_type == "REPAYMENT") && (
                <CustomApproved2CompletedFormDialog
                  actionType="ACH"
                  appId={appId}
                  record={record}
                  cb={handleNewAppStatus}
                />
              )}
              {showFinalizeButton && (
                <CustomApproved2CompletedFormDialog
                  actionType="Finalize"
                  appId={appId}
                  record={record}
                  cb={handleNewAppStatus}
                />
              )}
              {!showFinalizeButton &&
                attachAttrs.payment_type != "ACH" &&
                attachAttrs.payment_type != "REPAYMENT" && (
                  <CustomApproved2CompletedFormDialog
                    actionType="default"
                    appId={appId}
                    record={record}
                    cb={handleNewAppStatus}
                  />
                )}
            </>
          )}
        </>
      );
    }
  };

  const CounterActionButton = ({ record }: { record: any }) => {
    return (
      <>
        {record.sApplicationResponse != "Rejected" &&
          record.sApplicationResponse != "Accepted" &&
          record.sApplicationResponse != "Accept" && (
            <CustomCounterReminderDialog
              appId={appId}
              record={record}
              cb={handleNewAppStatus}
              handleCallBackRefreshMenu={handleCallBackRefreshMenu}
            />
          )}
        {record.is_expiration == 1 && (
          <CustomCounter2ExpiredDialog
            appId={appId}
            record={record}
            cb={handleNewAppStatus}
          />
        )}
        {record.sApplicationResponse != "Rejected" && (
          <>
            {record.sApplicationResponse != "" && (
              <>
                {record.sApplicationResponse == "Accept" ||
                record.sApplicationResponse == "Accepted" ||
                record.sApplicationResponse == "Agree" ? (
                  <>
                    <CustomCounter2ApproveDialog
                      appId={appId}
                      record={record}
                      cb={handleNewAppStatus}
                    />
                  </>
                ) : (
                  <CustomCounter2DeclineDialog
                    appId={appId}
                    record={record}
                    cb={handleNewAppStatus}
                  />
                )}
              </>
            )}
          </>
        )}
      </>
    );
  };

  const ExpiredActionButton = ({ record }: { record: any }) => {
    //show resend , offline, decline button
    return (
      <>
        <CustomExpired2ResendDialog
          appId={appId}
          record={record}
          cb={handleNewAppStatus}
        />
        {record.offline_btn == "YES" && (
          <CustomExpired2OfflineDialog
            appId={appId}
            record={record}
            cb={handleNewAppStatus}
          />
        )}
        <CustomExpired2DeclineDialog
          appId={appId}
          record={record}
          cb={handleNewAppStatus}
        />
      </>
    );
  };

  const PreApprovedActionButton = ({ record }: { record: any }) => {
    return (
      <>
        {record.sApplicationResponse != "Rejected" &&
          record.sApplicationResponse != "Accepted" &&
          record.sApplicationResponse != "Accept" && (
            <CustomPreApprove2ReminderDialog
              appId={appId}
              record={record}
              cb={handleNewAppStatus}
            />
          )}
        {record.is_expiration == 1 && (
          <CustomPreApprove2ExpiredDialog
            appId={appId}
            record={record}
            cb={handleNewAppStatus}
          />
        )}
        {record.sApplicationResponse != "Rejected" && (
          <>
            {record.sApplicationResponse != "" && (
              <>
                {(record.sApplicationResponse == "Accept" ||
                  record.sApplicationResponse == "Accepted" ||
                  record.sApplicationResponse == "Agree") && (
                  <>
                    {record?.sPreApproveNeedCounselorFile != "YES" && (
                      <CustomPreApprove2ApproveDialog
                        appId={appId}
                        record={record}
                        cb={handleNewAppStatus}
                      />
                    )}
                    {/* counselor had upload counselor file on Pre-Approved Accept */}
                    {/* {record?.sPreApproveNeedCounselorFile} */}
                    {record?.sPreApproveNeedCounselorFile == "YES" &&
                      record?.preapprove_counselor_filepath != "" && (
                        <CustomPreApprove2ApproveDialog
                          appId={appId}
                          record={record}
                          cb={handleNewAppStatus}
                        />
                      )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </>
    );
  };

  // Add “Expired” to the individual applications on the following pages (not the right most):
  // Pending Verification, Pending Acceptance, Pending Closing, On Hold
  const CustomShowExpiredDialog = ({
    appId,
    record,
    curStatus,
  }: {
    appId: any;
    record: any;
    curStatus: string;
  }) => {
    // "tBankProducts.expiration_days",
    // 	"tBankProducts.max_onhold_days",
    // 	"tBankProducts.underwriting_period_days",
    //   "tBankProducts.loanoffer_expiration",
    const currentDate = new Date();
    if (curStatus == "Pending Closing") {
      const loanoffer_expiration = Number(record?.loanoffer_expiration);
      const lastcounter_execTime = record?.lastcounter_execTime
        ? new Date(record.lastcounter_execTime)
        : null;
      if (
        lastcounter_execTime &&
        !Number.isNaN(lastcounter_execTime.getTime()) &&
        Number.isFinite(loanoffer_expiration) &&
        loanoffer_expiration > 0
      ) {
        const diffDays = Math.floor(
          (currentDate.getTime() - lastcounter_execTime.getTime()) /
            (1000 * 60 * 60 * 24)
        );
        // return (
        //   diffDays +
        //   " - {{" +
        //   loanoffer_expiration +
        //   "}} - " +
        //   record?.expired_at +
        //   "[" +
        //   record?.lastcounter_execTime +
        //   "]"
        // );
        if (diffDays > loanoffer_expiration) {
          return (
            <CustomApproved2ExpiredDialog
              appId={appId}
              record={record}
              cb={handleNewAppStatus}
            />
          );
        }
      }
    } else if (curStatus == "On Hold") {
      const maxOnholdDays = Number(record?.max_onhold_days);
      // const lastExecDate = record?.lastExecDate
      //   ? new Date(record.lastExecDate)
      //   : null;
      const lastExecDate = record?.dtDocusignComplete
        ? new Date(record.dtDocusignComplete)
        : null;
      if (
        lastExecDate &&
        !Number.isNaN(lastExecDate.getTime()) &&
        Number.isFinite(maxOnholdDays) &&
        maxOnholdDays > 0
      ) {
        const diffDays = Math.floor(
          (currentDate.getTime() - lastExecDate.getTime()) /
            (1000 * 60 * 60 * 24)
        );
        // return diffDays + " - " + maxOnholdDays;
        if (diffDays > maxOnholdDays) {
          return (
            <CustomExpiredDialog
              appId={appId}
              record={record}
              curStatus={curStatus}
            />
          );
        }
      }

      return null;
    } else if (curStatus == "New") {
      const submitDate = record?.dtDocusignComplete
        ? new Date(record.dtDocusignComplete)
        : null;
      const underwriting_period_days = Number(record?.underwriting_period_days);
      if (
        submitDate &&
        !Number.isNaN(submitDate.getTime()) &&
        Number.isFinite(underwriting_period_days) &&
        underwriting_period_days > 0
      ) {
        const diffDays = Math.floor(
          (currentDate.getTime() - submitDate.getTime()) / (1000 * 60 * 60 * 24)
        );
        // return diffDays + " - " + underwriting_period_days;
        if (diffDays > underwriting_period_days) {
          return (
            <CustomExpiredDialog
              appId={appId}
              record={record}
              curStatus={curStatus}
            />
          );
        }
      }
    } else if (curStatus == "Initial Review") {
      return (
        <CustomExpiredDialog
          appId={appId}
          record={record}
          curStatus={curStatus}
        />
      );
    }
  };
  if (appStatus == "New" || appStatus == "Check" || appStatus == "restart") {
    return (
      <Grid container>
        <Grid item xs={2} sx={{ textAlign: "left" }}>
          <Tooltip title="Back to Applications List" placement="left">
            <span className="app-back-link">
              {record?.showNextprocess == 1 ? (
                <Link to='/applications?filter={"status":"New","subStatus":"Ready for Review"}'>
                  <CustomArrowCircleLeftSharpIcon />
                </Link>
              ) : (
                <Link to='/applications?filter={"status":"New","subStatus":"Verification Pending"}'>
                  <CustomArrowCircleLeftSharpIcon />
                </Link>
              )}
            </span>
          </Tooltip>
          <MoveBulkUpdateButton
            appId={appId}
            status={record.sStatus}
            cb={handleNewAppStatus}
            record={record}
          />
        </Grid>
        <Grid item xs={10} sx={{ textAlign: "right" }}>
          {appStatus != "restart" && (
            <CustomShowExpiredDialog
              appId={appId}
              record={record}
              curStatus="New"
              // cb={handleNewAppStatus}
            />
          )}

          <CustomHoldFormDialog
            appId={appId}
            record={record}
            appStatus={appStatus}
            cb={handleNewAppStatus}
          />
          {/* --{record?.counselorVerifyStatus}---{record?.iEmployerVerification}-- */}
          <CustomInitiateReviewFormDialog
            appId={appId}
            record={record}
            cb={handleNewAppStatus}
          />
          {/* 如果是New状态， 不管是否employer, counselor 验证，都可以Initial
          {record.showNextprocess == 1 && (
            <CustomInitiateReviewFormDialog
              appId={appId}
              record={record}
              cb={handleNewAppStatus}
            />
          )}
           {record.showNextprocess != 1 && (
            <DisabledButtonWithTip
              tip="Invalid function. Application not ready."
              label="Initiate"
            />
          )} */}
        </Grid>
      </Grid>
    );
  } else if (appStatus == "Hold") {
    return (
      <Grid container>
        <Grid item xs={2} sx={{ textAlign: "left" }}>
          <Tooltip title="Back to Applications List" placement="left">
            <span className="app-back-link">
              <Link to='/applications?filter={"status":"Hold"}'>
                <CustomArrowCircleLeftSharpIcon />
              </Link>
            </span>
          </Tooltip>
          <MoveBulkUpdateButton
            appId={appId}
            status={record.sStatus}
            cb={handleNewAppStatus}
            record={record}
          />
        </Grid>
        <Grid item xs={10} sx={{ textAlign: "right" }}>
          <CustomShowExpiredDialog
            appId={appId}
            record={record}
            curStatus="On Hold"
            // cb={handleNewAppStatus}
          />
          <CustomHold2DeclinedFormDialog
            appId={appId}
            record={record}
            cb={handleNewAppStatus}
          />
          <CustomHold2ResumeFormDialog
            appId={appId}
            record={record}
            cb={handleNewAppStatus}
          />
        </Grid>
      </Grid>
    );
  } else if (appStatus == "Initial Review") {
    return (
      <Grid container>
        <Grid item xs={2} sx={{ textAlign: "left" }}>
          <Tooltip title="Back to Applications List" placement="left">
            <span className="app-back-link">
              <Link to='/applications?filter={"status":"Initial Review"}'>
                <CustomArrowCircleLeftSharpIcon />
              </Link>
            </span>
          </Tooltip>
          <MoveBulkUpdateButton
            appId={appId}
            status={record.sStatus}
            cb={handleNewAppStatus}
            record={record}
          />
        </Grid>
        <Grid item xs={10} sx={{ textAlign: "right" }}>
          <CustomShowExpiredDialog
            appId={appId}
            record={record}
            curStatus="Initial Review"
            // cb={handleNewAppStatus}
          />
          <CustomHoldFormDialog
            appId={appId}
            record={record}
            cb={handleNewAppStatus}
          />
          {requirementSaved == "yes" && (
            <>
              {record.sSubType == "car" || record.sPreApprove == "YES" ? (
                <CustomApprovedFormDialog
                  appId={appId}
                  record={record}
                  btnName="Pre-Approve"
                  cb={handleNewAppStatus}
                />
              ) : (
                <CustomApprovedFormDialog
                  appId={appId}
                  record={record}
                  cb={handleNewAppStatus}
                />
              )}
              {/* @if($data->subType != 'account' && $data->subType != 'car' && $data->sPreApprove != 'YES')  */}
              {record.sSubType != "account" &&
                record.sSubType != "car" &&
                record.sPreApprove != "YES" && (
                  <CustomCounteredFormDialog
                    appId={appId}
                    record={record}
                    cb={handleNewAppStatus}
                  />
                )}
              <CustomDeclinedFormDialog
                appId={appId}
                record={record}
                cb={handleNewAppStatus}
              />
            </>
          )}
          {requirementSaved == "no" && (
            <>
              {record.sSubType == "car" || record.sPreApprove == "YES" ? (
                <DisabledButtonWithTip
                  label="Pre-Approved"
                  tip="Underwriting must be completed to proceed with this function."
                  width="140px"
                  sx={{ marginLeft: "10px", width: "140px" }}
                />
              ) : (
                <DisabledButtonWithTip
                  label="Approve"
                  tip="Underwriting must be completed to proceed with this function."
                  sx={{ marginLeft: "10px", width: "120px" }}
                />
              )}
              <DisabledButtonWithTip
                label="Counter"
                tip="Underwriting must be completed to proceed with this function."
                sx={{ marginLeft: "10px", width: "120px" }}
              />
              <DisabledButtonWithTip
                label="Decline"
                tip="Underwriting must be completed to proceed with this function."
                sx={{ marginLeft: "10px", width: "120px" }}
              />
            </>
          )}
        </Grid>
      </Grid>
    );
  } else if (appStatus == "Final Review") {
    return (
      <Grid container>
        <Grid item xs={2} sx={{ textAlign: "left" }}>
          <Tooltip title="Back to Applications List" placement="left">
            <span className="app-back-link">
              <Link to='/applications?filter={"status":"Final Review"}'>
                <CustomArrowCircleLeftSharpIcon />
              </Link>
            </span>
          </Tooltip>
          <MoveBulkUpdateButton
            appId={appId}
            status={record.sStatus}
            cb={handleNewAppStatus}
            record={record}
          />
        </Grid>
        <Grid item xs={10} sx={{ textAlign: "right" }}>
          <CustomOverrideFormDialog
            appId={appId}
            record={record}
            cb={handleNewAppStatus}
          />
          <CustomRejectFormDialog
            appId={appId}
            record={record}
            cb={handleNewAppStatus}
          />
          <CustomProceedFormDialog
            appId={appId}
            record={record}
            cb={handleNewAppStatus}
          />
        </Grid>
      </Grid>
    );
  } else if (appStatus == "To Notify") {
    return (
      <Grid container>
        <Grid item xs={2} sx={{ textAlign: "left" }}>
          <Tooltip title="Back to Applications List" placement="left">
            <span className="app-back-link">
              <Link to='/applications?filter={"status":"To Notify"}'>
                <CustomArrowCircleLeftSharpIcon />
              </Link>
            </span>
          </Tooltip>
          <MoveBulkUpdateButton
            appId={appId}
            status={record.sStatus}
            record={record}
          />
        </Grid>
        <Grid item xs={10} sx={{ textAlign: "right" }}>
          {/* review:{record.sReview}--subtype:{record.sSubType}---sPreApprove
          {record.sPreApprove}--- sApplicationResponse:
          {record?.sApplicationResponse}---- */}
          {record.sReview == "Approved" ||
          record.sReview == "Pre-Approved" ||
          record.sReview == "pre-approve" ? (
            <>
              {record?.sBank == "ircceo" && (
                <CustomLoanPortfolioDialog appId={appId} record={record} />
              )}
              {record?.sBank == "nolb" && (
                <CustomLoanPortfolioDialog appId={appId} record={record} />
              )}
            </>
          ) : (
            <></>
          )}
          {record.sReview == "Approved" ||
          record.sReview == "Pre-Approved" ||
          record.sReview == "pre-approve" ? (
            // @if(($one->subType == 'car' || $one->preApprovePurpose == 'yes' ) && $one->isPreAccept == '')
            record.sSubType == "car" || record.sPreApprove == "YES" ? (
              <>
                {record?.sApplicationResponse == "Accepted" ||
                record?.sApplicationResponse == "Accept" ||
                record?.sApplicationResponse == "Rejected" ? (
                  <>
                    <CustomToNotify2ApprovedFormDialog
                      appId={appId}
                      record={record}
                      cb={handleNewAppStatus}
                    />
                  </>
                ) : (
                  <>
                    <CustomToNotify2PreApprovedFormDialog
                      appId={appId}
                      record={record}
                      cb={handleNewAppStatus}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <CustomToNotify2ApprovedFormDialog
                  appId={appId}
                  record={record}
                  cb={handleNewAppStatus}
                />
                {/* <CustomToNotifySBAFormDialog appId={appId} record={record} /> */}
              </>
            )
          ) : record.sReview == "Countered" || record.sReview == "Counter" ? (
            <CustomToNotify2CounteredFormDialog
              appId={appId}
              record={record}
              cb={handleNewAppStatus}
            />
          ) : record.sReview == "Expired" ? (
            <Button
              label="Expired"
              variant="contained"
              size="medium"
              color="inherit"
              sx={{ width: "120px", ml: 2 }}
              onClick={() => handleClick("Expired Pop-up ...")}
            />
          ) : record.sReview == "Declined" ? (
            <CustomToNotify2DeclinedFormDialog
              appId={appId}
              record={record}
              cb={handleNewAppStatus}
            />
          ) : (
            <CustomToNotify2DeclinedFormDialog
              appId={appId}
              record={record}
              cb={handleNewAppStatus}
            />
          )}
        </Grid>
      </Grid>
    );
  } else if (appStatus == "Approved" || appStatus == "Completed") {
    let iComplete = 0;
    if (record?.sExecuteStatus == "Closing Dos Received") {
      if (
        record?.sNeedDisbursement == "" ||
        record?.sNeedDisbursement == "No"
      ) {
        iComplete = 1;
      }
      if (record?.disbursementStatus == "succeed") {
        iComplete = 1;
      }
      if (
        record?.sDisbursementPayment == "SMART_ACH" &&
        record?.ach_account_id
      ) {
        iComplete = 1;
      }
    } else {
      iComplete = 0;
    }

    let new_disbursement_status = "";

    if (record?.disbursement_status == "no disbursement") {
      new_disbursement_status = "No Disbursement";
    } else {
      if (
        record?.disbursementStatus == "succeed" ||
        record?.disbursementStatus == "processed"
      ) {
        new_disbursement_status = "Disbursement Succeed";
      } else if (record?.disbursementStatus == "failed") {
        new_disbursement_status = "Disbursement Failed";
      } else {
        if (record?.sNeedDisbursement == "No") {
          new_disbursement_status = "No Disbursement";
        } else {
          new_disbursement_status = "Pending Disburse";
        }
      }
    }

    return (
      <Grid container>
        <Grid item xs={2} sx={{ textAlign: "left" }}>
          <Tooltip title="Back to Applications List" placement="left">
            <span className="app-back-link">
              {iComplete == 1 ? (
                <Link to='/applications?filter={"status":"Approved","subStatus":"Signature Completed"}'>
                  <CustomArrowCircleLeftSharpIcon />
                </Link>
              ) : (
                <Link to='/applications?filter={"status":"Approved","subStatus":"Pending Signature"}'>
                  <CustomArrowCircleLeftSharpIcon />
                </Link>
              )}
            </span>
          </Tooltip>
          <MoveBulkUpdateButton
            appId={appId}
            status={record.sStatus}
            cb={handleNewAppStatus}
            record={record}
          />
        </Grid>
        <Grid item xs={10} sx={{ textAlign: "right" }}>
          {record?.sExecuteStatus != "Closing Dos Received" && (
            <>
              <CustomShowExpiredDialog
                appId={appId}
                record={record}
                curStatus="Pending Closing"
                // cb={handleNewAppStatus}
              />
            </>
          )}
          {record?.sExecuteStatus == "Closing Dos Received" && (
            <>
              {new_disbursement_status != "No Disbursement" &&
              new_disbursement_status != "Disbursement Succeed" ? (
                <CustomApproved2ExpiredDialog
                  appId={appId}
                  record={record}
                  cb={handleNewAppStatus}
                />
              ) : (
                ""
              )}
            </>
          )}

          {record?.sExecuteStatus == "Closing Dos Received" ? (
            <>
              {record?.sBank == "ircceo" && (
                <CustomLoanPortfolioDialog appId={appId} record={record} />
              )}
              {record?.sBank == "nolb" && (
                <CustomLoanPortfolioDialog appId={appId} record={record} />
              )}
            </>
          ) : null}
          <BorrowerAgreement record={record} />
        </Grid>
      </Grid>
    );
  } else if (appStatus == "Countered") {
    return (
      <Grid container>
        <Grid item xs={2} sx={{ textAlign: "left" }}>
          <Tooltip title="Back to Applications List" placement="left">
            <span className="app-back-link">
              {record?.sApplicationResponse == "Accepted" ||
              record?.sApplicationResponse == "Accept" ||
              record?.sApplicationResponse == "Rejected" ? (
                <Link to='/applications?filter={"status":"CounteredAndPreApproved","subStatus":"Offer Accepted"}'>
                  <CustomArrowCircleLeftSharpIcon />
                </Link>
              ) : (
                <Link to='/applications?filter={"status":"CounteredAndPreApproved","subStatus":"Acceptance Pending"}'>
                  <CustomArrowCircleLeftSharpIcon />
                </Link>
              )}
            </span>
          </Tooltip>
          <MoveBulkUpdateButton
            appId={appId}
            status={record.sStatus}
            cb={handleNewAppStatus}
            record={record}
          />
        </Grid>
        <Grid item xs={10} sx={{ textAlign: "right" }}>
          {record?.sApplicationResponse == "Accepted" ||
          record?.sApplicationResponse == "Accept" ||
          record?.sApplicationResponse == "Rejected" ? (
            <>
              {record?.sBank == "ircceo" && (
                <CustomLoanPortfolioDialog appId={appId} record={record} />
              )}
              {record?.sBank == "nolb" && (
                <CustomLoanPortfolioDialog appId={appId} record={record} />
              )}
            </>
          ) : null}
          <CounterActionButton record={record} />
        </Grid>
      </Grid>
    );
  } else if (appStatus == "Pre-Approved") {
    return (
      <Grid container>
        <Grid item xs={2} sx={{ textAlign: "left" }}>
          <Tooltip title="Back to Applications List" placement="left">
            <span className="app-back-link">
              {record?.sApplicationResponse == "Accepted" ||
              record?.sApplicationResponse == "Accept" ||
              record?.sApplicationResponse == "Rejected" ? (
                <Link to='/applications?filter={"status":"CounteredAndPreApproved","subStatus":"Offer Accepted"}'>
                  <CustomArrowCircleLeftSharpIcon />
                </Link>
              ) : (
                <Link to='/applications?filter={"status":"CounteredAndPreApproved","subStatus":"Acceptance Pending"}'>
                  <CustomArrowCircleLeftSharpIcon />
                </Link>
              )}
            </span>
          </Tooltip>
          <MoveBulkUpdateButton
            appId={appId}
            status={record.sStatus}
            cb={handleNewAppStatus}
            record={record}
          />
        </Grid>
        <Grid item xs={10} sx={{ textAlign: "right" }}>
          {record?.sApplicationResponse == "Accepted" ||
          record?.sApplicationResponse == "Accept" ||
          record?.sApplicationResponse == "Rejected" ? (
            <>
              {record?.sBank == "ircceo" && (
                <CustomLoanPortfolioDialog appId={appId} record={record} />
              )}
              {record?.sBank == "nolb" && (
                <CustomLoanPortfolioDialog appId={appId} record={record} />
              )}
            </>
          ) : null}
          <PreApprovedActionButton record={record} />
        </Grid>
      </Grid>
    );
  } else if (appStatus == "Declined") {
    return (
      <Grid container>
        <Grid item xs={2} sx={{ textAlign: "left" }}>
          <Tooltip title="Back to Applications List" placement="left">
            <span className="app-back-link">
              {appVoided ? (
                <Link to='/applications?filter={"status":"Declined","subStatus":"voided"}'>
                  <CustomArrowCircleLeftSharpIcon />
                </Link>
              ) : (
                <Link to='/applications?filter={"status":"Declined"}'>
                  <CustomArrowCircleLeftSharpIcon />
                </Link>
              )}
            </span>
          </Tooltip>
          <MoveBulkUpdateButton
            appId={appId}
            status={record.sStatus}
            cb={handleNewAppStatus}
            record={record}
          />
        </Grid>
        <Grid item xs={10} sx={{ textAlign: "right" }}></Grid>
      </Grid>
    );
  } else if (appStatus == "Expired") {
    return (
      <Grid container>
        <Grid item xs={2} sx={{ textAlign: "left" }}>
          <Tooltip title="Back to Applications List" placement="left">
            <span className="app-back-link">
              <Link to='/applications?filter={"status":"Expired"}'>
                <CustomArrowCircleLeftSharpIcon />
              </Link>
            </span>
          </Tooltip>
        </Grid>
        <Grid item xs={10} sx={{ textAlign: "right" }}>
          <ExpiredActionButton record={record} />
        </Grid>
      </Grid>
    );
  } else {
    return <></>;
  }
};

export default ApplicationActions;
